const details = {
  webinar_summary: ["purpose_of_attending", "reason_for_participation"],
  webinar_full: [
    "company_name",
    "reason_for_participation",
    "designation",
    "website"
  ],
  webinar_full_associated: [
    "associated_industry",
    "website",
    "designation",
    "company_name"
  ],
  gym: [
    "current_height",
    "current_weight",
    "desired_weight",
    "fitness_level",
    "diet_preference",
    "monthly_budget"
  ],
  auth: ["genre", "language", "title", "author", "subtitle"]
};

export default details;
